import { BreakpointObserver } from '@angular/cdk/layout';
import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { BaseComponent } from 'src/app/shared';
import { WelcomeMessage } from '../../models/WelcomeMessageText';
import { Session } from '../../services/session.service';
import { LeaveLinkAccessService } from '../../services/leavelink-access.service';
import { emulator } from '../../services/emulator.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { UtilityService } from '../../services/utility.service';
import { TranslationService } from '../../services/translation.service';

@Component({
    selector: 'app-welcome',
    template: `
    <app-panel [canExpand]="false">
      <app-loading-panel [state]="'Loaded'">
        <ng-template #content>
          @for (item of welcomeMessage; track item) {
            <div
              [ngClass]="{
                'tw-flex tw-flex-wrap tw-w-full tw-items-center full-width-welcome':
                  !showMore,
                'tw-flex tw-flex-wrap tw-w-full tw-items-center truncate-text full-width-welcome':
                  showMore
              }"
            >
              <div class="tw-w-full">
                @if (
                  !utility.isNullOrEmpty(item?.welcomeMessageText) &&
                  ('WelcomeMessageText' | translationClientCustomization:item?.welcomeMessageText)
                ) {
                  <div class="app-pb2 app-pt3">
                    <div
                      [innerHTML]="
                      welcomeMessageTranslationKey(item)
                        | translationClientCustomization
                          : item?.welcomeMessageText
                          : translationRequest
                          : true
                        | safeHtml
                      "
                    ></div>
                  </div>
                }
              </div>
              @if (calloutsEnabled && !showMore) {
                <div class="tw-flex tw-flex-wrap tw-w-full">
                  <div class="tw-w-full md:tw-w-[50%] app-pl2">
                    <div class="callout app-pb2 app-pt2">
                      <mat-icon color="primary" class="callout-icon">arrow_circle_right</mat-icon>
                      <div class="callout-text">
                        <a href="#" class="callout-link">{{ item.callOutType1 }}</a><br />
                        {{ item.calloutMessage1 }}
                      </div>
                    </div>
                  </div>
                  <div class="tw-w-full md:tw-w-[50%] app-pl2">
                    <div class="callout app-pb2 app-pt2">
                      <mat-icon color="primary" class="callout-icon">arrow_circle_right</mat-icon>
                      <div class="callout-text">
                        <a href="#" class="callout-link">{{ item.callOutType2 }}</a><br />
                        {{ item.calloutMessage2 }}
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
              <div class="tw-w-full showMoreLink app-pt1">
                <a [routerLink]="" (click)="showMore = !showMore">
                  {{ (showMore ? 'Show more' : 'Show less') | translation : translationRequest }}
                </a>
              </div>
          }
        </ng-template>
      </app-loading-panel>
    </app-panel>
    `,
    styles: [
        `
      .callout {
        display: flex;
        align-items: top;
      }

      .callout-text {
        padding-top: 4px;
      }
      .callout-link {
        font-size: 16px;
        font-weight: bold;
      }

      .callout-icon {
        font-size: 30px;
        height: 30px;
        width: 30px;
        padding-right: 8px;
      }

      .showMoreLink {
        background-color: white;
      }

      .full-width-welcome {
        width: 100%;
        overflow: hidden;
      }

      .truncate-text {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    `,
    ],
    standalone: false
})
export class WelcomeComponent extends BaseComponent implements OnInit {
  showMore = false;
  calloutsEnabled = false;
  welcomeMessage: WelcomeMessage[];

  @Input()
  welcomeMessageInfo: any;

  @Input()
  translationRequest: TranslationRequest;

  @Output()
  showWelcomeMessageSection = new EventEmitter<boolean>();

  constructor(
    private breakpointObserver: BreakpointObserver,
    private session: Session,
    public utility: UtilityService,
    private leaveLinkAccessService: LeaveLinkAccessService,
    elementRef: ElementRef,
    renderer: Renderer2,
    private enumalatorService: emulator,
    private translationService: TranslationService
  ) {
    super();
    this.welcomeMessage = new Array<WelcomeMessage>();
    renderer.listen(elementRef.nativeElement, 'click', (event) => {
      const target = event.target || event.srcElement || event.currentTarget;

      if (
        this.session.user.isEmulating &&
        target.innerHTML === 'LeaveLink.' &&
        event.srcElement.nodeName == 'A'
      ) {
        event.preventDefault();
        this.enumalatorService.showAuditorInfo();
        return;
      }

      if (event.srcElement.nodeName == 'A' && target.id === 'leaveLinkSSO') {
        event.preventDefault();
        this.handleLeaveLinkAccess();
      }
    });
  }

  async ngOnInit() {
    this.subs.sink = this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .subscribe((result) => {
        this.showMore = result.matches;
      });
      if (this.translationService.isLanguagePreferenceSet()) {
        await this.translationService.mergeTranslationsFromRequest(
          new TranslationRequest({
            language: sessionStorage.getItem('languagepreference'),
            key: null,
            contNum: Number(this.session.user.contNum),
            tableName: null,
            primaryKey: null,
            primaryValue: null,
            lob: null,
            group: 'Shared',
            subGroup: 'Shared',
            multipleKeyAllowed: 'WelcomeMessageText',
            saveToCache: false,
          })
        );
      }
  
    this.welcomeMessageInfo = await this.session.GetWelcomeMessage();

    const welcomeData = this.welcomeMessageInfo[0];

    if (
      this.welcomeMessageInfo === null ||
      this.welcomeMessageInfo === undefined ||
      this.welcomeMessageInfo.length === 0
    ) {
      this.showWelcomeMessageSection.emit(false);
    }
    this.welcomeMessage.push(welcomeData);
  }

  welcomeMessageTranslationKey(detail: WelcomeMessage): string {
    if (detail?.welcomeMessageId == null) {
      return 'WelcomeMessageText';
    }
    return `WelcomeMessageText|${detail.welcomeMessageId}`;
  }

  handleLeaveLinkAccess() {
    this.leaveLinkAccessService.handleLeaveLinkAccess();
  }
}
